<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tabela de Taxas</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Taxas</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      Tipo de conta
                    </th>
                    <th scope="col" class="border-0 text-left">
                      Método de pagamento
                    </th>
                    <th scope="col" class="border-0 text-left">Tipo de taxa</th>
                    <th scope="col" class="border-0">Taxa</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(configurationTax, index) in configurationTaxes"
                    :key="index"
                  >
                    <td></td>
                    <td class="text-left">
                      {{ configurationTax.MerchantType.Name }}
                    </td>
                    <td class="text-left">
                      {{ configurationTax.PaymentMethod.Name }}
                    </td>
                    <td class="text-left">
                      {{ configurationTax.TaxType.Name }}
                    </td>
                    <td v-if="configurationTax.TaxType.Code == 1">
                      {{ configurationTax.Amount | percentage }}
                    </td>
                    <td v-else>{{ configurationTax.Amount | currency }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('ConfigurationTax', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              GetConfigurationTax(
                                $event,
                                configurationTax.Id,
                                true
                              )
                            "
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('ConfigurationTax', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              GetConfigurationTax($event, configurationTax.Id)
                            "
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('ConfigurationTax', 'Delete')"
                            class="dropdown-item disabled"
                            href="#"
                            v-on:click="
                              DeleteConfigurationTax(
                                $event,
                                configurationTax.Id
                              )
                            "
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      configurationTaxes == undefined ||
                      configurationTaxes == null ||
                      configurationTaxes.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormConfigurationTax"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <loader :is-loading="loadingModal"></loader>

      <div v-if="!loadingModal">
        <ValidationObserver tag="form" ref="ConfigurationValidationForm">
          <!-- MerchantType -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Tipo de conta</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  v-model="infoConfigurationTax.MerchantType.Code"
                  :class="
                    validatedConfigurationForm | showValidateError(invalid)
                  "
                  :value="null"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="type in merchantTypes"
                    v-bind:key="type.Code"
                    v-bind:value="type.Code"
                  >
                    {{ type.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedConfigurationForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- PaymentMethod -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Método de pagamento</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  v-model="infoConfigurationTax.PaymentMethod.Code"
                  :class="
                    validatedConfigurationForm | showValidateError(invalid)
                  "
                  :value="null"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="type in paymentMethods"
                    v-bind:key="type.Code"
                    v-bind:value="type.Code"
                  >
                    {{ type.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedConfigurationForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- TaxType -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Tipo de taxa</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  v-model="infoConfigurationTax.TaxType.Code"
                  :class="
                    validatedConfigurationForm | showValidateError(invalid)
                  "
                  :value="null"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="type in taxTypes"
                    v-bind:key="type.Code"
                    v-bind:value="type.Code"
                  >
                    {{ type.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedConfigurationForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- InitialInstallment -->
          <d-form-row v-if="infoConfigurationTax.PaymentMethod.Code == 2">
            <d-col md="6" class="form-group">
              <label>Parcela inicial</label>
              <ValidationProvider
                rules="required|min_value:0"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="number"
                  :class="
                    validatedConfigurationForm | showValidateError(invalid)
                  "
                  min="0"
                  v-model="infoConfigurationTax.InitialInstallment"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedConfigurationForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

            <!-- EndInstallment -->
            <d-col md="6" class="form-group">
              <label>Parcela final</label>
              <ValidationProvider
                rules="required|min_value:0"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="number"
                  :class="
                    validatedConfigurationForm | showValidateError(invalid)
                  "
                  min="0"
                  v-model="infoConfigurationTax.EndInstallment"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedConfigurationForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- Amount -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label v-if="infoConfigurationTax.TaxType.Code == 1"
                >Percentual</label
              >
              <label v-else>Valor</label>
              <ValidationProvider
                rules="required|min_value:0.01"
                v-slot="{ errors, invalid }"
              >
                <decimal-field
                  v-model="infoConfigurationTax.Amount"
                  :class="
                    validatedConfigurationForm | showValidateError(invalid)
                  "
                  :disabled="isSeeing"
                  :type="
                    infoConfigurationTax.TaxType.Code == 1
                      ? 'percentage'
                      : 'currency'
                  "
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedConfigurationForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveConfigurationTax()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ idOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeTaxType" :value="null">
            <option :value="null" selected>Tipo de taxa</option>
            <option
              v-for="type in taxTypes"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeMerchantType" :value="null">
            <option :value="null" selected>Tipo de conta</option>
            <option
              v-for="type in merchantTypes"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodePaymentMethod" :value="null">
            <option :value="null" selected>Método de pagamento</option>
            <option
              v-for="type in paymentMethods"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('ConfigurationTax', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Nova configuração"
      v-on:click="OpenNewConfigurationTax($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import DecimalField from "../common/decimal-field.vue";
import { hasValue } from "../../utils/functions.js";
export default {
  name: "configuration-taxes",
  components: {
    DecimalField,
  },
  data: function () {
    return {
      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      countFilter: 0,
      modalTitle: "Nova configuração",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        CodePaymentMethod: null,
        CodeTaxType: null,
        CodeMerchantType: null,
      },
      idOpened: null,
      isSeeing: false,
      configurationTaxes: [],
      infoConfigurationTax: {
        MerchantType: {
          Code: null,
        },
        PaymentMethod: {
          Code: null,
        },
        TaxType: {
          Code: null,
        },
        Amount: null,
        InitialInstallment: 0,
        EndInstallment: 0,
      },
      merchantTypes: [],
      paymentMethods: [],
      taxTypes: [],
      validatedConfigurationForm: false,
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListConfigurationTax();
    },
    "pagination.RowsPerPage": function () {
      this.ListConfigurationTax();
    },
  },
  mounted() {
    this.ListConfigurationTax();
    this.$store
      .dispatch("ListMerchantType")
      .then((response) => {
        this.merchantTypes = response;
      })
      .catch((error) => {
        this.$makeToast(
          undefined,
          "danger",
          "Erro ao obter a lista de tipos de conta",
          error
        );
      });

    this.$store
      .dispatch("ListPaymentMethodIsEnabled")
      .then((response) => {
        this.paymentMethods = response.Objects;
      })
      .catch((error) => {
        this.$makeToast(
          undefined,
          "danger",
          "Erro ao obter a lista de métodos de pagamento",
          error
        );
      });

    this.$store
      .dispatch("ListTaxType")
      .then((response) => {
        this.taxTypes = response;
      })
      .catch((error) => {
        this.$makeToast(
          undefined,
          "danger",
          "Erro ao obter a lista de tipos de taxa",
          error
        );
      });
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListConfigurationTax();
    },
    ResetFilter: function () {
      this.filter = {
        CodePaymentMethod: null,
        CodeTaxType: null,
        CodeMerchantType: null,
      };
      this.ListConfigurationTax();
    },
    ShowConfigurationTax: function () {
      this.$bvModal.show("mFormConfigurationTax");
    },
    HideConfigurationTax: function () {
      this.$bvModal.hide("mFormConfigurationTax");
    },
    OpenNewConfigurationTax: function () {
      this.ResetConfigurationTax();
      this.idOpened = null;
      this.isSeeing = false;
      this.validatedConfigurationForm = false;
      this.modalTitle = "Nova configuração";
      this.ShowConfigurationTax();
    },
    ResetConfigurationTax: function () {
      this.infoConfigurationTax = {
        MerchantType: {
          Code: null,
        },
        PaymentMethod: {
          Code: null,
        },
        TaxType: {
          Code: null,
        },
        Amount: null,
        InitialInstallment: 0,
        EndInstallment: 0,
      };
    },
    DeleteConfigurationTax: function (e, id) {
      e.preventDefault();
      this.$store
        .dispatch("DeleteConfigurationTax", { id: id })
        .then(() => {
          this.$makeToast(
            "A configuração foi removida da sua base de dados",
            "success",
            "Configuração removida"
          );
          this.ListConfigurationTax();
          this.HideConfigurationTax();
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover a configuração",
            error
          );
        });
    },
    GetConfigurationTax: function (e, id, seeing) {
      e.preventDefault();
      this.loadingModal = true;
      this.validatedConfigurationForm = false;
      this.idOpened = id;

      if (typeof seeing != "undefined") {
        this.isSeeing = true;
        this.modalTitle = "Detalhes da configuração";
      } else {
        this.isSeeing = false;
        this.modalTitle = "Editar configuração";
      }

      this.ShowConfigurationTax();
      this.ResetConfigurationTax();

      this.$store
        .dispatch("GetConfigurationTax", { id: id })
        .then((response) => {
          this.infoConfigurationTax = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar a configuração",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    ListConfigurationTax: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.CodePaymentMethod)) this.countFilter++;
      if (hasValue(this.filter.CodeTaxType)) this.countFilter++;
      if (hasValue(this.filter.CodeMerchantType)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.PaymentMethod.Code": this.filter.CodePaymentMethod,
          "Object.TaxType.Code": this.filter.CodeTaxType,
          "Object.MerchantType.Code": this.filter.CodeMerchantType,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListConfigurationTax", { params: data })
        .then((response) => {
          this.configurationTaxes = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as configurações",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    SaveConfigurationTax: function () {
      this.validatedConfigurationForm = true;

      this.$refs.ConfigurationValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;
          if (!this.idOpened) {
            this.$store
              .dispatch("AddConfigurationTax", this.infoConfigurationTax)
              .then(() => {
                this.$makeToast(
                  "A configuração foi cadastrada corretamente na base de dados",
                  "success",
                  "Configuração cadastrada"
                );
                this.ListConfigurationTax();
                this.HideConfigurationTax();
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao criar a configuração",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            this.$store
              .dispatch("UpdateConfigurationTax", this.infoConfigurationTax)
              .then(() => {
                this.$makeToast(
                  "Suas modificações foram salvas na base de dados",
                  "success",
                  "Configuração atualizada"
                );
                this.ListConfigurationTax();
                this.HideConfigurationTax();
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao atualizar a configuração",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/configurationTaxes.vue